import {createEntityAdapter} from '@reduxjs/toolkit'
import { IModelOptionType } from '../../types'

export const modelOptionTypesAdapter = createEntityAdapter<IModelOptionType>()